import { isValidSocialNumber } from '@@viewValidations';
import ControlledInput from './ControlledInput';
import { useEffect } from 'react';

const ControlledSSInput = ({
  SSInputName = '',
  birthDateInputName,
  label,
  form,
  mandatory,
  containerClassName = '',
  isDisplayed = true,
  ...extraProps
}) => {
  if (!isDisplayed) {
    return null;
  }
  const rules = {
    ...isValidSocialNumber(!birthDateInputName ? form.watch(birthDateInputName) : null, mandatory)
  };

  useEffect(() => {
    form.trigger(SSInputName);
    return () => {
      form.clearErrors(SSInputName);
    };
  }, [form.trigger, form.clearErrors, SSInputName]);

  return (
    <div className={`w-full flex md:w-[100%]! ${containerClassName}`}>
      <ControlledInput
        form={form}
        name={SSInputName}
        label={label}
        errors={form.formState.errors}
        rules={rules}
        mask="9 99 99 9* 999 999 99"
        maskPlaceholder=" "
        containerClassName="w-full! md:w-full!"
        {...extraProps}
      />
    </div>
  );
};

export default ControlledSSInput;
